import { render, staticRenderFns } from "./productDefine.vue?vue&type=template&id=20957456&scoped=true"
import script from "./productDefine.vue?vue&type=script&lang=js"
export * from "./productDefine.vue?vue&type=script&lang=js"
import style0 from "./productDefine.vue?vue&type=style&index=0&id=20957456&lang=scss&scoped=true"
import style1 from "./productDefine.vue?vue&type=style&index=1&id=20957456&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20957456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20957456')) {
      api.createRecord('20957456', component.options)
    } else {
      api.reload('20957456', component.options)
    }
    module.hot.accept("./productDefine.vue?vue&type=template&id=20957456&scoped=true", function () {
      api.rerender('20957456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/productDefine.vue"
export default component.exports